import { gettext } from '../../services'
import { EventEmitter, renderIcon } from '../../utility'

/**
 * Map control with a checkbox to toggle if filters should be updated when moving or zooming.
 * @see https://docs.mapbox.com/mapbox-gl-js/api/?size=n_10_n#icontrol
 */
export default class SearchOnMapMoveControl extends EventEmitter {

    /** @type {Object} */
    _map

    /** @type {boolean} */
    _value

    /** @type {HTMLDivElement} */
    _container

    /** @type {HTMLInputElement} */
    _input

    /**
     * @param {boolean} [initialValue=true] Initial value (true for checked)
     */
    constructor(initialValue = true) {
        super()

        this._value = initialValue
        this._handleChange = this._handleChange.bind(this)
    }

    /** @inheritdoc */
    onAdd(map) {
        this._map = map
        this._container = document.createElement('div')
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group bikemap-ctrl update-filters-ctrl'

        const label = document.createElement('label')
        label.className = 'checkbox-field'

        label.append(this._createLabelText(gettext('Search as I move the map'), 'hidden-xs'))
        label.append(this._createLabelText(gettext('Search'), 'hidden visible-xs'))

        this._input = document.createElement('input')
        this._input.type = 'checkbox'
        this._input.checked = this._value
        this._input.addEventListener('change', this._handleChange)

        label.prepend(this._input)
        this._container.append(label)

        label.prepend(renderIcon('i-check', 'primary'))

        return this._container
    }

    /** @inheritdoc */
    onRemove() {
        this._container.parentNode.removeChild(this._container)
        this._map = undefined
        this._input.removeEventListener('change', this._handleChange)
    }

    /**
     * Handles change events on the input.
     */
    _handleChange() {
        this._value = this._input.checked
        this._dispatchEvent('change', this._value)
    }

    /** @type {boolean} */
    get value() { return this._value }

    set value(newVal) {
        this._value = newVal
        if (this._input) this._input.checked = newVal
    }

    /**
     * @param {string} text
     * @param {string} className
     * @returns {HTMLSpanElement}
     */
    _createLabelText(text, className) {
        const labelText = document.createElement('span')
        labelText.className = className
        labelText.textContent = text
        return labelText
    }

}
